import DateFnsUtils from '@date-io/date-fns';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import EventIcon from '@material-ui/icons/Event';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import clsx from 'clsx';
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import CountryList from '../../../components/Data/countries.json';
import api from '../../../config/api';
import CompanyData from '../companyData.json';
import ContactData from '../contactData.json';
import matchSorter from 'match-sorter';
import DataSearch from '../../../components/DataSearch';
import { combineNames } from '../../../utils/combineNames';
import { Delete } from '../../../components/Icons';

const filterOptions = (options, { inputValue }) =>
	matchSorter(options, inputValue);

const useStyles = makeStyles((theme) => ({
	expand: {
		transform: 'rotate(0deg)',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},
	card: {
		marginBottom: 16,
		backgroundColor: theme.palette.background.default,
	},
	cardContent: {
		padding: 24,
		paddingTop: 0,
	},
}));

const getNationality = (val) => {
	let obj = CountryList.find((item) => item.code === val);
	return obj.label;
};

export default function AssociatedContactForm(props) {
	const classes = useStyles();
	const theme = useTheme();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 768 });
	const [open, setOpen] = useState(true);
	const [contact, setContact] = useState(props.contact);
	const [loading, setLoading] = useState(false);
	const [contacts, setContacts] = useState([]);

	const prepareData = () => {
		setLoading(true);
		setContacts(ContactData);
		setLoading(false);
	};

	const getContacts = () => {
		setLoading(true);
		api
			.get('contacts')
			.then((response) => {
				setContacts(response.data);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
			});
	};
	useEffect(() => {
		if (contact.isExisting) {
			prepareData();
		}
	}, [contact.isExisting]);

	const toggleOpen = () => {
		if (!open) {
			setOpen(true);
		}
		setOpen(!open);
	};

	return (
		<Card className={classes.card}>
			<CardHeader
				title={
					<>
						<div
							style={{
								display: 'flex',
								alignItems: isDesktopOrLaptop && 'center',
								flexDirection: isDesktopOrLaptop ? 'row' : 'column',
							}}
						>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<IconButton
									className={clsx(classes.expand, {
										[classes.expandOpen]: open,
									})}
									style={{ marginRight: 8 }}
									onClick={() => toggleOpen()}
									aria-expanded={open}
									aria-label='show more'
								>
									<ExpandMoreIcon />
								</IconButton>
								{contact.formData.firstName ? (
									<>
										<Typography color='textPrimary' variant='h5'>
											{combineNames({
												fName: contact.formData.firstName,
												mName:
													contact.formData.middleName !== undefined
														? contact.formData.middleName
														: null,
												lName:
													contact.formData.lastName !== undefined
														? contact.formData.lastName
														: null,
											})}
										</Typography>
									</>
								) : (
									`[Name of Contact ${props.index}]`
								)}
							</div>
							{isDesktopOrLaptop ? (
								<>
									{contact.isPrimary && (
										<Chip
											style={{
												marginLeft: 16,
												color: theme.palette.background.secondary,
												backgroundColor: theme.palette.tertiary.main,
											}}
											label='Primary Contact'
										/>
									)}
									<div style={{ marginLeft: 'auto' }}>
										<Button
											style={{ marginRight: 8 }}
											variant='outlined'
											color='primary'
											disabled={contact.isPrimary}
											onClick={() => props.handleChangePrimary(contact.id)}
										>
											Set as Primary
										</Button>
										<Button
											color='primary'
											disabled={props.disableRemove}
											startIcon={
												<Delete
													style={{ fontSize: 24 }}
													colorcode={
														props.disableRemove
															? theme.palette.grey[500]
															: theme.palette.tertiary.main
													}
												/>
											}
											onClick={() => props.handleRemoveContact(contact.id)}
										>
											Remove
										</Button>
									</div>
								</>
							) : (
								<div
									style={{
										marginLeft: 'auto',
										display: 'flex',
										alignItems: 'center',
									}}
								>
									{contact.isPrimary ? (
										<Chip
											style={{
												marginLeft: 16,
												width: 'fit-content',
												color: theme.palette.background.secondary,
												backgroundColor: theme.palette.tertiary.main,
											}}
											label='Primary Contact'
										/>
									) : (
										<Button
											style={{ marginLeft: 16, width: 'fit-content' }}
											variant='outlined'
											color='primary'
											disabled={contact.isPrimary}
											onClick={() => props.handleChangePrimary(contact.id)}
										>
											Set as Primary
										</Button>
									)}
									<IconButton
										style={{
											color:
												!props.disableRemove && theme.palette.tertiary.main,
										}}
										disabled={props.disableRemove}
										onClick={() => props.handleRemoveContact(contact.id)}
									>
										<Delete
											style={{ fontSize: 24 }}
											colorcode={
												props.disableRemove
													? theme.palette.grey[500]
													: theme.palette.tertiary.main
											}
										/>
									</IconButton>
								</div>
							)}
						</div>
					</>
				}
			/>
			<Collapse in={open} timeout='auto' unmountOnExit>
				<CardContent classes={{ root: classes.cardContent }}>
					<FormControl style={{ marginBottom: 16 }} component='fieldset'>
						<RadioGroup
							aria-label='existing'
							name='isExisting'
							value={contact.isExisting}
							onChange={(e) => props.handleChangeExisting(e, props.index)}
						>
							<FormControlLabel
								value={false}
								control={<Radio color='primary' />}
								label='New Contact'
							/>
							<FormControlLabel
								value={true}
								control={<Radio color='primary' />}
								label='Existing Contact'
							/>
						</RadioGroup>
					</FormControl>
					{contact.isExisting && (
						<div style={{ width: 330, marginBottom: 24 }}>
							<DataSearch
								type='contact'
								handleSelectRecord={props.handleSelectContact}
								index={props.index}
							/>
							{/* {props.showDuplicateMessage && (
										<Typography style={{marginLeft: 2}} color='error' variant='body2'>
											Selected option already chosen
										</Typography>
									)} */}
						</div>
					)}
					{(!contact.isExisting || contact.existingId) && (
						<Grid container spacing={4}>
							<Grid item xs={12} sm={4}>
								<Grid container justifyContent='flex-start'>
									<Typography color='textPrimary' variant='body2' align='left'>
										First Name
									</Typography>
									<Typography
										style={{ marginLeft: 2 }}
										color='error'
										variant='body2'
										align='right'
									>
										*
									</Typography>
								</Grid>
								<TextField
									name='firstName'
									value={contact.formData.firstName}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's First Name" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.firstName`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.firstName`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.firstName`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Middle Name
								</Typography>
								<TextField
									name='middleName'
									value={contact.formData.middleName}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's Middle Name" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.middleName`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.middleName`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.middleName`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Last Name
								</Typography>
								<TextField
									name='lastName'
									value={contact.formData.lastName}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's Last Name" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.lastName`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.lastName`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.lastName`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Date of Birth
								</Typography>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										name='dob'
										disableToolbar
										placeholder={!contact.existingId ? 'DD/MM/YYYY' : ''}
										inputVariant={!contact.existingId ? 'filled' : 'standard'}
										openTo='year'
										views={['year', 'month', 'date']}
										disabled={!contact.existingId ? false : true}
										InputProps={{
											disableUnderline: !!contact.existingId,
											style: { color: 'unset' },
										}}
										format='dd/MM/yyyy'
										disableFuture
										margin='dense'
										fullWidth
										value={contact.formData.dob ? contact.formData.dob : null}
										autoOk
										variant='inline'
										maxDate={new Date()}
										invalidDateMessage='Invalid Date Format'
										onChange={(date) =>
											props.handleContactDateChange(props.index, 'dob', date)
										}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
										keyboardIcon={!contact.existingId && <EventIcon />}
										error={
											!!props.errorMessages[
												`contacts.${props.index}.formData.dob`
											]
										}
										helperText={
											props.errorMessages[
												`contacts.${props.index}.formData.dob`
											] &&
											props.errorMessages[
												`contacts.${props.index}.formData.dob`
											]
										}
									/>
								</MuiPickersUtilsProvider>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Gender
								</Typography>
								<>
									{contact.existingId ? (
										<TextField
											name='gender'
											value={
												contact.formData.gender ? contact.formData.gender : ''
											}
											disabled={true}
											InputProps={{
												disableUnderline: true,
												style: {
													color: 'unset',
													textTransform: 'capitalize',
												},
											}}
											inputProps={{ style: { textTransform: 'capitalize' } }}
											variant='standard'
											fullWidth
											margin='dense'
										/>
									) : (
										<Select
											native
											name='gender'
											value={contact.formData.gender}
											onChange={(e) =>
												props.handleContactInputChange(e, props.index)
											}
											variant='filled'
											fullWidth
											autoWidth={true}
											margin='dense'
											style={{ marginTop: 8, marginBottom: 4 }}
										>
											<option value=''></option>
											<option value='male'>Male</option>
											<option value='female'>Female</option>
										</Select>
									)}
								</>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Marital Status
								</Typography>
								<>
									{contact.existingId ? (
										<TextField
											name='maritalStatus'
											value={
												contact.formData.maritalStatus
													? contact.formData.maritalStatus
													: ''
											}
											disabled={true}
											InputProps={{
												disableUnderline: true,
												style: {
													color: 'unset',
													textTransform: 'capitalize',
												},
											}}
											inputProps={{ style: { textTransform: 'capitalize' } }}
											variant='standard'
											fullWidth
											margin='dense'
										/>
									) : (
										<Select
											native
											name='maritalStatus'
											value={contact.formData.maritalStatus}
											onChange={(e) =>
												props.handleContactInputChange(e, props.index)
											}
											variant='filled'
											fullWidth
											autoWidth={true}
											margin='dense'
											style={{ marginTop: 8, marginBottom: 4 }}
										>
											<option value=''></option>
											<option value='single'>Single</option>
											<option value='married'>Married</option>
										</Select>
									)}
								</>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Nationality
								</Typography>
								<>
									{contact.existingId ? (
										<TextField
											name='nationality'
											value={
												contact.formData.nationality
													? getNationality(contact.formData.nationality)
													: ''
											}
											disabled={true}
											InputProps={{
												disableUnderline: true,
												style: {
													color: 'unset',
													textTransform: 'capitalize',
												},
											}}
											variant='standard'
											fullWidth
											margin='dense'
										/>
									) : (
										<Select
											native
											name='nationality'
											value={contact.formData.nationality}
											onChange={(e) =>
												props.handleContactInputChange(e, props.index)
											}
											variant='filled'
											fullWidth
											autoWidth={true}
											margin='dense'
											style={{ marginTop: 8, marginBottom: 4 }}
										>
											<option key={0} value=''></option>
											{CountryList.sort(
												(a, b) => -b.label.localeCompare(a.label)
											).map((country, index) => {
												return (
													<option key={index} value={country.code}>
														{country.label}
													</option>
												);
											})}
										</Select>
									)}
								</>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									NRIC / FIN / Passport No.
								</Typography>
								<TextField
									name='idNo'
									value={contact.formData.idNo}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId
											? "Enter Client's NRIC / FIN / Passport No."
											: ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.idNo`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.idNo`
										] &&
										props.errorMessages[`contacts.${props.index}.formData.idNo`]
									}
								/>
							</Grid>
							<Grid item sm={4} />
							<Grid item xs={12} sm={4}>
								<Grid container justifyContent='flex-start'>
									<Typography color='textPrimary' variant='body2' align='left'>
										Email
									</Typography>
									<Typography
										style={{ marginLeft: 2 }}
										color='error'
										variant='body2'
										align='right'
									>
										*
									</Typography>
								</Grid>
								<TextField
									name='email'
									value={contact.formData.email}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's Email Address" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.email`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.email`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.email`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Mobile
								</Typography>
								<TextField
									name='mobileNo'
									value={contact.formData.mobileNo}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's Mobile Number" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.mobileNo`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.mobileNo`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.mobileNo`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Home
								</Typography>
								<TextField
									name='homeNo'
									value={contact.formData.homeNo}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId ? "Enter Client's Home Number" : ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.homeNo`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.homeNo`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.homeNo`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Address
								</Typography>
								<TextField
									name='address'
									value={contact.formData.address}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={
										!contact.existingId
											? "Enter Client's Blk / House No. / Street Address"
											: ''
									}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.address`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.address`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.address`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Floor / Unit Number
								</Typography>
								<TextField
									name='unitNo'
									value={contact.formData.unitNo}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={!contact.existingId ? 'Enter Unit No.' : ''}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.unitNo`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.unitNo`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.unitNo`
										]
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Typography color='textPrimary' variant='body2'>
									Postal / Zip Code
								</Typography>
								<TextField
									name='postalCode'
									value={contact.formData.postalCode}
									onChange={(e) =>
										props.handleContactInputChange(e, props.index)
									}
									placeholder={!contact.existingId ? 'Enter Postal Code' : ''}
									disabled={!contact.existingId ? false : true}
									InputProps={{
										disableUnderline: !!contact.existingId,
										style: { color: 'unset' },
									}}
									variant={!contact.existingId ? 'filled' : 'standard'}
									fullWidth
									margin='dense'
									error={
										!!props.errorMessages[
											`contacts.${props.index}.formData.postalCode`
										]
									}
									helperText={
										props.errorMessages[
											`contacts.${props.index}.formData.postalCode`
										] &&
										props.errorMessages[
											`contacts.${props.index}.formData.postalCode`
										]
									}
								/>
							</Grid>
						</Grid>
					)}
				</CardContent>
			</Collapse>
		</Card>
	);
}
